import React, { useState } from "react";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { useParams } from "react-router-dom";
import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import { Avatar, Pagination, Popconfirm, Table, Tag, message } from "antd";
import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";
import {
  CheckOutlined,
  CloseOutlined,
  DeleteTwoTone,
  UserOutlined,
} from "@ant-design/icons";
import EditableImage from "../../../../components/icons/EditIcon";
import axiosInstance from "../../../../api/Axios";

function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let i = 0; i < cookies.length; i++) {
    const [cookieName, cookieValue] = cookies[i].split("=");
    if (cookieName === name) {
      return cookieValue;
    }
  }
  return null;
}

const UploadManager = (props) => {
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };

  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    passSize: 10,
    passPage: 1,
    passURL: `/customer/uploadlist/?organization_id=${id}`,
    loadAgain: loadAgain,
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;

  const handleDelete = async (uploadId) => {
    try {
      const csrfToken = getCookie("csrftoken");
      await axiosInstance.delete(`/customer/upload/`, {
        params: { id: uploadId },
        data: "",
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      message.success("Upload deleted successfully");
      LoadAPI();
    } catch (error) {
      console.error("Error deleting upload:", error);
      message.error(error?.response?.data?.message || "Failed to delete upload");
    }
  };
  const renderStatus = (text, record) => {
    if (text === "success") {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#52c41a",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CheckOutlined
              style={{ color: "#fff", fontSize: "1.2rem", fontWeight: "700" }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            style={{
              width: "1.8rem",
              height: "1.8rem",
              borderRadius: "50%",
              backgroundColor: "#ff4d4f",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CloseOutlined
              style={{ color: "#fff", fontSize: "1rem", fontWeight: "600" }}
            />
          </div>
        </div>
      );
    }
    // else {
    //   return text;
    // }
  };
  const columns = [
    {
      title: "Upload ID",
      dataIndex: "upload_id",
      key: "upload_id",
      width: 135,
    },
    {
      title: "Upload Time",
      dataIndex: "created_at",
      key: "created_at",
      width: 140,
      render: (text) => GetFormattedDateTime(text, true),
    },
    {
      title: "Records",
      dataIndex: "record_count",
      key: "record_count",
      width: 140,
      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
          }}
        >
          {text && text !== 0 ? (
            <Tag
              color="blue"
              style={{
                fontSize: "1.15rem",
                width: "2.5rem",
                height: "2.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                fontWeight: "600",
                padding: 0,
              }}
            >
              {text}
            </Tag>
          ) : null}
        </div>
      ),
    },
    {
      title: "Uploaded By",
      dataIndex: "first_name",
      key: "first_name",
      width: 200,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar
            src={record?.created_by?.avatar || null}
            icon={!record?.created_by?.avatar && <UserOutlined />}
            alt={record?.created_by?.full_name}
            size="small"
          />
          <span>{record?.created_by?.full_name}</span>
        </div>
      ),
    },

    {
      title: "State",
      dataIndex: "state",
      key: "state",
      render: renderStatus,
      width: 80,
    },
    ...(true
      ? [
        {
          title: "Actions",
          dataIndex: "id",
          key: "id",
          align: "center",
          width: 100,
          fixed: "right",
          render: (text, record) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <EditableImage
                handleRowClick={() => {
                  const uploadId = record.id;
                  if (props.setUploadId) {
                    props.setUploadId(uploadId);
                  }
                  if (props.setCurrent) {
                    props.setCurrent("upload_details");
                  }
                }}
                recordId={record}
                passSize="small"
                disabled={props?.canEdit === false}
              />
              <Popconfirm
                title={"Delete Upload?"}
                description="Are you sure you want to delete this upload?"
                onConfirm={() => handleDelete(record.id)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
                disabled={props?.canEdit === false}
                placement="leftTop"
              >
                <DeleteTwoTone
                  style={{
                    cursor: props?.canEdit === false ? "not-allowed" : "pointer",
                    fontSize: "1.6rem",
                    marginLeft: "0.7rem",
                    opacity: props?.canEdit === false ? 0.5 : 1,
                  }}
                  title="Archive"
                  twoToneColor={props?.canEdit === false ? "#d9d9d9" : "#eb2f96"}
                />
              </Popconfirm>
            </div>
          ),
          onCell: (record) => ({
            onClick: (e) => {
              e.stopPropagation();
            },
          }),
        },
      ]
      : []),
  ];
  console.log(props);
  return (
    <div>
      <CommonTopDetails
        title={`User Upload Manager`}
        titleSuffix={`${itemsLength || 0} unit(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showUploadButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="5px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        uploadButtonProps={{
          modalType: "PopUP",
          modalProps: () => {
            props.setCurrent("excel");
          },
          disabled: props?.canEdit === false,
        }}
      />
      <>
        <Table
          columns={columns}
          dataSource={data}
          onRow={(record) => {
            return {
              onClick: () => {
                const uploadId = record.id;
                if (props.setUploadId) {
                  props.setUploadId(uploadId);
                }
                if (props.setCurrent) {
                  props.setCurrent("upload_details");
                }
              },
              style: { cursor: "pointer" },
            };
          }}
          rowKey="id"
          size="small"
          loading={loading}
          className="table-container"
          style={{ margin: "1rem" }}
          pagination={false}
          scroll={{ x: 400 }}
          bordered
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["5", "10", "15", "20", "50"]}
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </>
    </div>
  );
};

export default UploadManager;
